import { useRouter } from "next/router"
import CheckList from "../../components/content/CheckList"
import stateCityDictionary, {
  formatName,
  urlifyName,
} from "../../constants/stateCityDictionary"

export default function PetTransportWays() {
  const router = useRouter()
  const { city, state } = router.query

  const formattedState = formatName(state as string)
  const urlifiedCity = city ? urlifyName(city as string) : ""

  const originalCity =
    stateCityDictionary[formattedState]?.cities.find(
      (dictCity) => urlifyName(dictCity) === urlifiedCity,
    ) ?? ""

  const formattedCity = originalCity ? formatName(originalCity) : ""

  return (
    <section id="PetTransportWays" className="page-padding bg-gray11">
      <h3 className="max-w-[35ch] mx-auto mb-10 font-medium font-montserrat text-blue7 text-3xl text-center">
        How to find the best pet transport service in{" "}
        {formattedCity ? `${formattedCity}, ${formattedState}` : formattedState}
        ?
      </h3>
      <p className="max-w-prose mx-auto mb-10 text-xl text-center">
        Of course you want to hire the best pet transport service to ship your
        pet to or from{" "}
        {formattedCity ? `${formattedCity}, ${formattedState}` : formattedState}
        . But what steps do you take to find the right{" "}
        {formattedCity ? formattedCity : formattedState} pet transport company?
      </p>
      <p className="max-w-prose mx-auto mb-10 text-xl text-center">
        There are many obstacles to pet shipping, whether it’s price, the age of
        your puppy or kitten, availability of transporters, business hours or a
        pet that can’t be transported via airplane.
      </p>
      <CheckList
        items={[
          "It’s hard to estimate the cost of pet transportation because there are so many variables.",
          "Look for driver profiles on CitizenShipper that include detailed information about past experience, special equipment and professional qualifications like USDA T Registration.",
          "You can discuss every trip detail with transporters using CitizenShipper’s internal messaging system.",
          "Cost is always a consideration, but sometimes the best pet transporters charge more for superior service — your pet’s comfort and your peace of mind are well worth it.",
        ]}
      />
    </section>
  )
}
